// extracted by mini-css-extract-plugin
module.exports = {"IAndCArchiveAdvisor":"IAndCArchiveAdvisor_IAndCArchiveAdvisor__3Ml4z"};